import styled from 'styled-components';
import { SupportedLanguages } from './typesForCommonLib';

export const randomString = (length: number): string => {
    let result = '';
    const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * characters.length),
        );
    }
    return result;
};

export function capitalizeFirstChar(str: string): string {
    if (str.length === 0) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const getCityFromTimezone = (
    timezone: string,
    lang: SupportedLanguages,
) => {
    const formatter = new Intl.DateTimeFormat(lang, {
        timeZone: timezone,
        timeZoneName: 'longOffset',
    });

    const parts = formatter.formatToParts(new Date());

    const gmtOffset =
        parts.find((part) => part.type === 'timeZoneName')?.value || '';
    const city = timezone.split('/').pop()?.replace('_', ' ') ?? timezone;

    return { city, gmtOffset };
};

export const SROnly = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;
